import { render, staticRenderFns } from "./BlockSubcanvas.vue?vue&type=template&id=0dfef54e&scoped=true"
import script from "./BlockSubcanvas.vue?vue&type=script&lang=js"
export * from "./BlockSubcanvas.vue?vue&type=script&lang=js"
import style0 from "./BlockSubcanvas.vue?vue&type=style&index=0&id=0dfef54e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfef54e",
  null
  
)

export default component.exports